import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Situation } from 'src/app/shared/models/situation';
import { FacadeService } from 'src/app/core/services/facade.service';
import { User } from 'src/app/shared/models/security/user';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { LogService } from 'src/app/core/services/log/log.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { SituationModalDetailComponent } from '../modal/situation-modal-detail/situation-modal-detail.component';
import { SituationModalAjoutComponent } from '../modal/situation-modal-ajout/situation-modal-ajout.component';

export type SortOrder = 'asc' | 'desc';

@Component({
	selector: 'app-list-situation',
	templateUrl: './list-situation.component.html',
	styleUrls: ['./list-situation.component.scss']
})
export class ListSituationComponent implements OnInit {
	situation: Situation[] = [];
	currentPage = 1;
	itemsPerPage = 10;

	situationCsvFile: File = null;
	searchedSkill = '';
	searchedName = '';

	dismissible: true;
	alerts: any[] = [];

	nextWeekNumber: number;

	user: User = null;

	isAddable = false;
	isImportable = false;

	sortType = 'firstName';
	sortOrder: SortOrder = 'asc';

	searchedText: string;

	editSituationModalRef: BsModalRef;
	addSituationModalRef: BsModalRef;
	screenWidth: number;
	isMobile: boolean = false;

	isListingLoading: boolean = true;

	constructor(
		private router: Router,
		private facade: FacadeService,
		private modalService: BsModalService,
		private logger: LogService
	) {}

	@HostListener('window:resize', ['$event'])
	onWindowResize() {
		this.screenWidth = window.innerWidth;
		if (this.screenWidth < 1200) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	}

	ngOnInit(): void {
		this.screenWidth = window.innerWidth;
		this.isMobile =
			this.facade.mobileService.isMobile() || this.screenWidth < 1200;

		this.user = this.facade.dataStorageService.getUser();
		this.getSituation();
		this.isAddable = true;
	}

	getSituation(): void {
		this.isListingLoading = true;
		this.facade.situationService.getAllSituation().subscribe({
			next: (val) => {
				this.situation = val.filter((e) => e.name !== 'Sans');
				this.itemsPerPage = this.situation.length >= 8 ? 10 : 8;

				this.isListingLoading = false;
			},
			error: (err: ErrorResponse) => {
				this.logger.error(err + '');
				this.isListingLoading = false;
				this.situation = [];
			}
		});
	}

	selectSituation(situation: Situation): void {
		const link = ['/situation', situation.id];
		this.router.navigate(link);
	}

	importSituation(event: any): void {
		this.situationCsvFile = event.target.files[0];

		this.facade.situationService
			.importSituation(this.situationCsvFile)
			.subscribe({
				next: (importStats: ImportResponse) => {
					this.alerts.push({
						type: 'success',
						msg: `${importStats.entitiesAdded} situation ont été ajoutés,
                  ${importStats.entitiesBeforeImport} étaient déjà présents.`
					});

					this.getSituation();
				},
				error: (err) => {
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
					this.logger.error(
						'' + err.status + ' ' + err.error.message ? err.error.message : ''
					);
				}
			});
	}

	onClosed(dismissedAlert: any): void {
		this.alerts = this.alerts.filter((alert) => alert !== dismissedAlert);
	}

	openModalAjout() {
		this.facade.authenticationService.checkIsAuthenticated();
		this.addSituationModalRef = this.modalService.show(
			SituationModalAjoutComponent,
			{
				class: 'modal-lg',
				backdrop: 'static'
			}
		);

		this.addSituationModalRef.onHide.subscribe((reason: string | any) => {
			this.getSituation();
		});
	}

	sortChange(str: string) {
		if (str === this.sortType) {
			if (this.sortOrder === 'asc') {
				this.sortOrder = 'desc';
			} else {
				this.sortOrder = 'asc';
			}
		} else {
			this.sortType = str;
			this.sortOrder = 'asc';
		}
	}

	openModalEdit(situation: Situation) {
		const initialState = {
			situation: situation
		};
		this.editSituationModalRef = this.modalService.show(
			SituationModalDetailComponent,
			{
				class: '',
				initialState
			}
		);

		this.editSituationModalRef.onHide.subscribe((reason: string | any) => {
			this.getSituation();
		});
	}
}
